import React from 'react';
import { usePopup } from '../context/PopupContext';

const LandingPageHeader = () => {
  const { openPopup } = usePopup();

  const handleChatClick = () => {
    // Open Tawktrik chat widget
    if (typeof window.cd360Api !== 'undefined' && window.cd360Api && window.cd360Api.liveChat) {
      try {
        window.cd360Api.liveChat.showWebWidget();
      } catch (e) {
        console.log('Tawktrik widget error:', e);
        alert('Chat is loading. Please try again in a moment.');
      }
    } else {
      console.log('Tawktrik widget not loaded yet');
      alert('Chat widget is loading. Please try again in a moment.');
    }
  };

  return (
    <header className="bg-white shadow-md sticky top-0 z-50">
      <div className="container mx-auto px-4 max-w-[1320px]">
        <div className="flex items-center justify-between py-3 sm:py-4">
          {/* Logo */}
          <div className="flex items-center">
            <img 
              src="/assets/img/brand/logo-dark.png" 
              alt="Trademark Vector" 
              className="h-8 sm:h-10 md:h-12 w-auto"
            />
          </div>

          {/* Buttons */}
          <div className="flex items-center gap-2 sm:gap-4">
            {/* Register Button - Responsive text */}
            <button
              onClick={openPopup}
              className="bg-[#C0392B] hover:bg-[#A93226] text-white px-2 py-2 sm:px-6 sm:py-3 rounded-md font-bold text-[10px] xs:text-xs sm:text-base transition-all duration-300 hover:shadow-lg whitespace-nowrap leading-tight"
            >
              <span className="hidden min-[380px]:inline">Register My Trademark</span>
              <span className="min-[380px]:hidden">Register</span>
            </button>
            {/* Chat Button */}
            <button
              onClick={handleChatClick}
              className="bg-white text-[#C0392B] border-2 border-[#C0392B] hover:bg-[#C0392B] hover:text-white px-2 py-2 sm:px-6 sm:py-3 rounded-md font-bold text-[10px] xs:text-xs sm:text-base transition-all duration-300 whitespace-nowrap leading-tight"
            >
              <span className="hidden min-[380px]:inline">Chat Now</span>
              <span className="min-[380px]:hidden">Chat</span>
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default LandingPageHeader;